import { Calendar, Clock, MapPin, ChevronRight, FileText, Download, CheckCircle2 } from "lucide-react";

const AGENDA = [
  "Presentazione dell'associazione",
  "Aggiornamento sulle attività svolte",
  "Situazione del territorio dopo l'incendio",
  "Progetti e attività future",
  "Raccolta di proposte e segnalazioni dei cittadini",
  "Organizzazione dei gruppi di volontariato",
  "Domande e confronto aperto",
];

const REPORT_PDF = "/documenti/report-riunione-19-giugno-2026.pdf";

export const CittadiniMeeting = () => {
  return (
    <section
      id="riunione"
      data-testid="cittadini-meeting-section"
      className="relative bg-gradient-to-br from-[#0f1a14] via-[#1f2d22] to-[#2E4F3B] text-white py-20 sm:py-28 overflow-hidden"
    >
      <div className="pointer-events-none absolute -top-32 -right-32 w-[600px] h-[600px] rounded-full bg-[#7BA577]/[0.12] blur-3xl" />
      <div className="pointer-events-none absolute -bottom-40 -left-32 w-[500px] h-[500px] rounded-full bg-[#E8C9A0]/[0.08] blur-3xl" />

      <div className="relative max-w-6xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-12">
          {/* LEFT */}
          <div className="lg:col-span-7">
            <div className="inline-flex items-center gap-2 rounded-full bg-[#E8C9A0]/15 border border-[#E8C9A0]/40 px-4 py-2 mb-6">
              <CheckCircle2 className="w-3.5 h-3.5 text-[#E8C9A0]" />
              <span className="text-[10px] sm:text-xs font-bold uppercase tracking-[0.22em] text-[#E8C9A0]">
                Evento concluso · 19 giugno 2026
              </span>
            </div>

            <h2
              data-testid="meeting-title"
              className="font-display text-4xl sm:text-5xl lg:text-6xl font-black leading-[0.95] tracking-tight"
            >
              Prima Riunione
              <br />
              <span className="italic font-light text-[#E8C9A0]">
                Aperta ai Cittadini.
              </span>
            </h2>

            <p className="mt-7 text-lg sm:text-xl text-white/85 leading-relaxed max-w-xl">
              La prima riunione aperta dell'associazione si è tenuta il
              19 giugno 2026 ad Asciano. È stato un momento importante di
              confronto, ascolto e progettazione condivisa con i cittadini.
            </p>

            {/* Agenda */}
            <div className="mt-9">
              <div className="text-xs font-bold uppercase tracking-[0.22em] text-[#E8C9A0] mb-4">
                Argomenti trattati
              </div>
              <ul className="space-y-3">
                {AGENDA.map((item, i) => (
                  <li
                    key={i}
                    data-testid={`agenda-item-${i}`}
                    className="flex items-start gap-3"
                  >
                    <ChevronRight className="w-5 h-5 text-[#E8C9A0] shrink-0 mt-0.5" />
                    <span className="text-base sm:text-lg text-white/90 leading-snug">
                      {item}
                    </span>
                  </li>
                ))}
              </ul>
            </div>

            <p className="mt-9 text-base text-white/75 italic">
              Ringraziamo tutti i cittadini che hanno partecipato.
            </p>
          </div>

          {/* RIGHT */}
          <div className="lg:col-span-5">
            <div className="lg:sticky lg:top-28 rounded-3xl bg-white text-[#1A1A1A] p-7 sm:p-8 shadow-2xl">
              <div className="inline-flex items-center gap-2 rounded-full bg-[#2E4F3B]/10 text-[#2E4F3B] px-3 py-1.5 text-[10px] font-bold uppercase tracking-[0.22em] mb-5">
                <CheckCircle2 className="w-3 h-3" />
                Evento concluso
              </div>

              <div className="space-y-5">
                <div className="flex items-start gap-4 pb-5 border-b border-[#E5E1D8]">
                  <div className="w-12 h-12 rounded-xl bg-[#2E4F3B] text-white flex items-center justify-center shrink-0">
                    <Calendar className="w-6 h-6" />
                  </div>
                  <div className="flex-1 leading-tight">
                    <div className="text-[10px] font-bold uppercase tracking-wider text-[#5C5C5C] mb-1">
                      Data
                    </div>
                    <div className="font-display text-xl sm:text-2xl font-black text-[#1A1A1A]">
                      Venerdì 19 giugno 2026
                    </div>
                  </div>
                </div>

                <div className="flex items-start gap-4 pb-5 border-b border-[#E5E1D8]">
                  <div className="w-12 h-12 rounded-xl bg-[#2E4F3B] text-white flex items-center justify-center shrink-0">
                    <Clock className="w-6 h-6" />
                  </div>
                  <div className="flex-1 leading-tight">
                    <div className="text-[10px] font-bold uppercase tracking-wider text-[#5C5C5C] mb-1">
                      Orario
                    </div>
                    <div className="font-display text-xl sm:text-2xl font-black text-[#1A1A1A]">
                      19:30 - 20:00
                    </div>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 rounded-xl bg-[#2E4F3B] text-white flex items-center justify-center shrink-0">
                    <MapPin className="w-6 h-6" />
                  </div>
                  <div className="flex-1 leading-tight">
                    <div className="text-[10px] font-bold uppercase tracking-wider text-[#5C5C5C] mb-1">
                      Luogo
                    </div>
                    <div className="font-display text-2xl sm:text-3xl font-black text-[#1A1A1A]">
                      Asciano
                    </div>
                  </div>
                </div>
              </div>

              {/* Report download */}
              <div className="mt-7 pt-5 border-t border-[#E5E1D8]">
                <div className="text-[10px] font-bold uppercase tracking-[0.22em] text-[#C15C3D] mb-3">
                  Report della serata
                </div>
                <div className="rounded-2xl bg-[#FBF9F6] border-2 border-[#E5E1D8] p-4 flex items-center gap-3 mb-3">
                  <div className="w-11 h-11 rounded-xl bg-[#1A1A1A] text-white flex items-center justify-center shrink-0">
                    <FileText className="w-5 h-5" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="font-display font-bold text-sm text-[#1A1A1A] truncate">
                      Report riunione 19/06/2026
                    </div>
                    <div className="text-xs text-[#5C5C5C]">PDF · Sintesi dei punti discussi</div>
                  </div>
                </div>
                <a
                  href={REPORT_PDF}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="meeting-report-view"
                  className="block w-full text-center rounded-full bg-[#1A1A1A] hover:bg-[#2E4F3B] text-white font-bold px-5 py-3 transition-colors mb-2 inline-flex items-center justify-center gap-2"
                >
                  <FileText className="w-4 h-4" />
                  Apri il report
                </a>
                <a
                  href={REPORT_PDF}
                  download
                  data-testid="meeting-report-download"
                  className="block w-full text-center rounded-full bg-transparent border-2 border-[#1A1A1A] text-[#1A1A1A] hover:bg-[#1A1A1A] hover:text-white font-bold px-5 py-3 transition-colors inline-flex items-center justify-center gap-2"
                >
                  <Download className="w-4 h-4" />
                  Scarica il report
                </a>
              </div>

              <div className="mt-5 pt-5 border-t border-[#E5E1D8]">
                <a
                  href="/partecipa"
                  data-testid="meeting-volunteer-cta"
                  className="block w-full text-center rounded-full bg-[#C15C3D] hover:bg-[#a64830] text-white font-bold px-5 py-3 transition-colors"
                >
                  Diventa volontario
                </a>
                <p className="mt-3 text-xs text-[#5C5C5C] text-center">
                  Hai una segnalazione o un'idea?{" "}
                  <a href="/segnalazioni" className="underline font-semibold">
                    Scrivici
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
